<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="menu.inventoryStateConfig" mode="text" status="primary"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(type)"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="list" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="orderType.no" title="business.label.orderTypeNo" width="150"/>
        <vxe-column field="orderType.name" title="business.label.orderTypeName" width="200"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:inventoryStates}" field="inventoryState" title="business.label.inventoryState" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="defaults" title="business.label.defaults" width="60"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:warehouses}" field="warehouse.id" title="business.label.warehouse"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:owners}" field="owner.id" title="business.label.owner"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <vxe-modal v-model="visible" :loading="loading" title="menu.inventoryStateConfig" type="confirm" width="40%" @confirm="confirm">
      <vxe-form ref="form" :data="config" :rules="rules" span="12">
        <vxe-form-item :item-render="{name:'VxeInput',props:{disabled:true}}" field="orderType.no" title="business.label.orderTypeNo"/>
        <vxe-form-item :item-render="{name:'VxeInput',props:{disabled:true}}" field="orderType.name" title="business.label.orderTypeName"/>
        <vxe-form-item :item-render="{name:'VxeSelect',options:inventoryStates}" field="inventoryState" title="business.label.inventoryState"/>
        <vxe-form-item :item-render="{name:'VxeSwitch'}" field="defaults" title="business.label.defaults"/>
        <vxe-form-item :item-render="{name:'VxeSelect',options:warehouses}" field="warehouse.id" title="business.label.warehouse"/>
        <vxe-form-item :item-render="{name:'VxeSelect',options:owners}" field="owner.id" title="business.label.owner"/>
      </vxe-form>
    </vxe-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { ENTERPRISE } from '@/store/mutation-types'
import { deleteOne, findAll, findOne, save } from '@/api/Api'
import { OrderType } from '@/api/dto/common/OrderType'
import { InventoryStateConfig } from '@/api/dto/config/InventoryStateConfig'

export default {
  props: {
    inventoryStates: { type: Array, default: () => [] },
    warehouses: { type: Array, default: () => [] },
    owners: { type: Array, default: () => [] }
  },
  data() {
    return {
      enterprise: Vue.ls.get(ENTERPRISE),
      loading: false,
      visible: false,
      type: new OrderType(),
      list: [],
      config: new InventoryStateConfig(),
      rules: {
        inventoryState: [{ required: true, message: this.$t('message.cannotBeEmpty') }]
      }
    }
  },
  methods: {
    refresh(type) {
      this.type = type
      if (this.type.isNew()) {
        return this.$message.warning('请先选择订单类型')
      }
      this.loading = true
      findAll('inventoryStateConfigFactory', { 'orderType.id': this.type.id }).then(res => {
        if (res.success) {
          this.list = res.result.map(item => {
            return new InventoryStateConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.visible = true
      this.config = new InventoryStateConfig()
      this.config.orderType = this.type
    },
    edit(row, copy) {
      this.visible = true
      this.loading = true
      findOne('inventoryStateConfigFactory', { id: row.id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.config = new InventoryStateConfig(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const config = this.config.toJSONObject()
      config.enterprise = this.enterprise
      save('inventoryStateConfigPersister', config).then(res => {
        if (res.success) {
          this.config = new InventoryStateConfig(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.refresh(this.type)
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    async confirm() {
      if (!await this.$refs.form.validate()) this.save()
    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('inventoryStateConfigDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.refresh(this.type)
            this.$message.success(this.$t('message.deleteSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.list.splice(this.list.indexOf(row), 1)
      }
    }
  }
}
</script>